import { gql, useMutation } from '@apollo/client';

import { GET_HOLIDAY_SUBGROUP } from './get-holiday-subgroup-by-id.hook';

export const UPDATE_HOLIDAY_SUBGROUP = gql`
  mutation updateHolidaySubGroup($payload: UpdateHolidaySubGroupInput!) {
    updateHolidaySubGroup(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateHolidaySubGroup = () => {
  const [updateHolidaySubGroup] = useMutation(UPDATE_HOLIDAY_SUBGROUP, {
    refetchQueries: [GET_HOLIDAY_SUBGROUP],
  });

  return updateHolidaySubGroup;
};
